import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom';
import RouterPath from 'libs/RouterPath';
import NotFound from "../../NotFound/NotFound";
import AnnualReportsList from "./list/AnnualReportsList";
import AnnualReportPage from "./report/AnnualReportPage";
import moment from "libs/moment";

const rp = RouterPath.annualReport;

function AnnualReport() {

    return (<>
            <Switch>
                <Route path={rp.MP_ANNUAL_REPORT_YEAR_LIST} component={AnnualReportsList}/>
                <Route path={rp.MP_ANNUAL_REPORT_REPORT_ID_TABLE} component={AnnualReportPage}/>
                <Route path={rp.MP_ANNUAL_REPORT_REPORT_ID} component={AnnualReportPage}/>
                <Route path={rp.MP_ANNUAL_REPORT}>
                    <Redirect to={RouterPath.createPath(rp.MP_ANNUAL_REPORT_YEAR_LIST, {year: moment().year() - 1})} push={false}/>
                </Route>
                <Route component={NotFound}/>
            </Switch>
        </>
    )
}

export default AnnualReport;

